import { render, staticRenderFns } from "./ImpactCards.vue?vue&type=template&id=f18f5aa0"
import script from "./ImpactCards.vue?vue&type=script&setup=true&lang=ts"
export * from "./ImpactCards.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ImpactCards.vue?vue&type=style&index=0&id=f18f5aa0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@7.0.0-bridge.0_@babel+core@7.26.0__cache-loader@4.1.0_webpack@4_duly6tfyc62fvcli236pnhbyri/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ExportCardScaled: require('/home/runner/work/assessment-service/assessment-service/frontend/components/export/CardScaled.vue').default,ExportCardFlowing: require('/home/runner/work/assessment-service/assessment-service/frontend/components/export/CardFlowing.vue').default})
